import VerificationInput from "react-verification-input";

const InputVerificationCode = ({ value, onChange }: { value: string; onChange: (value: string) => void }) => {
  return (
    <VerificationInput
      value={value}
      length={5}
      placeholder=""
      validChars="0-9"
      autoFocus
      // the phone's number pad, and the code that arrived by e-mail offered above the keyboard
      inputProps={{ inputMode: "numeric", pattern: "[0-9]*", autoComplete: "one-time-code" }}
      onChange={(value: string) => onChange(value)}
      classNames={{
        character:
          "flex justify-center items-center bg-transparent border border-solid ring-white outline-white rounded-lg !w-12 !h-12 text-center text-white text-lg typography-p focus:ring-2 focus:ring-offset-2 focus:ring-offset-transparent focus:ring-white focus:outline-none",
      }}
    />
  );
};

export default InputVerificationCode;
